export const isField = (dropId) => dropId.split("-")[0] === "column";
export const isColumn = (dropId) => dropId.split("-")[0] === "group";
export const isRow = (dropId) => dropId.split("-")[0] === "base";
export const isUIblockList = (dropId) => dropId === "uiBlocks-list";

/******* Pomocne funkcie pre ziskanie ID riadku/stlpca ********/

const getColumnId = (dropId) => parseInt(dropId.split("-")[2]);
export const getRowId = (dropId) => parseInt(dropId.split("-")[1]);
export const getIDs = (dropId) => ({ rowId: getRowId(dropId), colId: getColumnId(dropId) });

/**************************************************************/

/*********************** Predikaty ****************************/
// Ma sa vytvorit stlpec?
export const shouldCreateColumn = (dropId) =>
  dropId.split("-")[0] === "addColumn";
// Ma sa vytvorit riadok so stlpcom?
export const shouldCreateRowWithColumn = (dropId) =>
  dropId.split("-")[0] === "addRowWithColumn";
// Bol blok presunuty do buildArea?
export const movedToBuildArea = (destination) =>
  destination !== "uiBlocks-list";

/**************************************************************/

/************** Procedury pre upravu zoznamov *****************/
//Hlboka kopia zoznamov stateu 

export const deepCopy = (list) => {
  if (!Array.isArray(list)) {
    return {...list};
  }

  return list.map((layer) => deepCopy(layer));
}

// Uprava v ramci toho isteho zoznamu (preusporiadanie elementov tahanim)
export const updateList = (list, dragResult, withData = true) => {
  const [deletedField] = withData ? list.data.splice(dragResult.source.index, 1) : list.splice(dragResult.source.index, 1);
  if (withData)
    list.data.splice(dragResult.destination.index, 0, deletedField);
  else
    list.splice(dragResult.destination.index, 0, deletedField);
};
// Presun medzi dvoma roznymi zoznamami
export const moveToList = (sourceList, destinationList, dragResult) => {
  const [deletedField] = sourceList.data.splice(dragResult.source.index, 1);
  destinationList.data.splice(dragResult.destination.index, 0, deletedField);
  if (destinationList.data.length === 3) {destinationList = editWidth(destinationList)} // upravit
  return destinationList;
};

/**************************************************************/

/****** Uprava sirky fieldu na auto pri plnom riadku **********/

export const editWidth = (row) => {
  var x = {type: "row", data: row.data.map(( col ) =>
    ({type: "column", data: col.data.map((comp) =>
      {
        if (comp?.field || comp.ui_type === "title" || comp.ui_type === "customComponent") {
          return { ...comp, customWidth: "" };
        }

        return comp;
      })
    })
  )}
  return x;
}  

/**************************************************************/


/*********** Procedury pre upravu stateu buildArea ************/

export const createColumn = (movedField, buildArea, dropId, toFront) => {
  const rowId = getRowId(dropId);
  return buildArea.map((row, i) => {
    if (i !== rowId) return row;

    const newData = toFront 
      ? [{ type: "column", data: [movedField] }, ...row.data] 
      : [...row.data, { type: "column", data: [movedField] }] 

    const newRow = { type: row.type, data: newData };

    return newRow.data.length === 3 ? editWidth(newRow) : newRow;
  });
};


export const addToColumn = (movedField, buildArea, dropId, result) => {
  const rowId = getRowId(dropId);
  const columnId = getColumnId(dropId);
  const destinationIndex = parseInt(result.destination.index);
  return buildArea.map((row, rowIndex) => {
    if (rowIndex !== rowId) return row;
    return {
      ...row,
      data: row.data.map((column, columnIndex) => {
        if (columnIndex !== columnId) return column;
        let updatedColumn = { type: column.type, data: [...column.data] };
        updatedColumn.data.splice(destinationIndex, 0, movedField);
        return updatedColumn;
      }),
    };
  });
};

/**************************************************************/

/***  Funkcia pre vratenie bloku (field) do materskeho zoznamu ***/
// uiBlock zoznam (detailSchema)
export const returnUiBlock = (result, sourceList, uiBlocks, dropId) => {
  const column = get2Delement(dropId, sourceList);
  const [deletedField] = column.splice(result.source.index, 1);
  uiBlocks.splice(result.destination.index, 0, deletedField);
  return { newBuildArea: sourceList, newUiBlocks: uiBlocks };
};

/*********************************************************/

/*** Pomocne funkcie pre vyberanie elementov zo zoznamov ***/

// 1 dimenzionalny zoznam
export const getElement = (dropId, sourceList) => {
  const index = getRowId(dropId);
  return sourceList[index];
};
// 2 dimenzionalny zoznam
export const get2Delement = (dropId, sourceList) => {
  const rowId = getRowId(dropId);
  const columnId = getColumnId(dropId);
  return sourceList[rowId].data[columnId].data;
}

/*********************************************************/
